export const enum VideoSettingsEnum {
  AUTOPLAY = 'Autoplay',
  MUTED = 'Muted',
  LOOP = 'Loop'
}

export type VideoSettingsOption = `${VideoSettingsEnum}`;
